import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { Modal } from "react-bootstrap";
import UserIcon from "../../assets/img/user-icon.svg";

const SuccessAwardedPropModal = (props) => {
  const { _t } = useTranslator();
  const {
    showSuccessPopup,
    setShowSuccessPopup,
    property,
    successTenant,
    onClose,
  } = props;

  const handleClose = () => {
    setShowSuccessPopup(false);
    onClose?.();
  };

  return (
    <>
      <Modal
        show={showSuccessPopup}
        onHide={handleClose}
        centered
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardPropertyModal text-center"
      >
        <Modal.Header>
          <div className="cursor-pointer" onClick={handleClose}>
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="checkmarkWrapper">
            <img src="/images/checkmarkIconGreen.svg" alt="" />
          </div>
          <h2>
            {_t(
              "propertyAwardedSuccessfully",
              "New award property succes modal"
            )}
          </h2>
          <p>
            {_t("theProperty", "New award property succes modal")}{" "}
            <span>
              {`${property?.street || ""}${
                !Number.isNaN(parseInt(property?.street_number, 10))
                  ? ` - ${parseInt(property?.street_number, 10)}`
                  : ""
              }${property?.floor_number ? `, ${property.floor_number}` : ""}${
                property?.flat_number ? `-${property.flat_number}` : ""
              }`}
            </span>
            {_t("hasBeenAwardedTo", "New award property succes modal")}
          </p>
          <ul>
            {successTenant?.map((tenantName) => (
              <li>
                <div className="earner-thumbnail-wrapper d-flex align-items-center justify-content-center">
                  <img src={UserIcon} alt="User Icon" />
                </div>
                {tenantName}
              </li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btngreen add-landlord-submit"
            onClick={handleClose}
          >
            {_t(
              "underStoodButtonAfterAwardProp",
              "New award property succes modal"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SuccessAwardedPropModal;
